import React from 'react'
import styled, { css } from 'styled-components'
import { layoutMaxSize, ZIndex } from 'src/styles/mixin'
import Button, { ButtonOption3 } from 'src/components/common/Button'
import { Container } from 'src/components/common/Container'
import {
  Noto_body1_m16,
  Noto_body1_r16,
  Noto_body2_b14,
  Noto_body2_r14,
  Noto_body3_m12,
} from 'src/styles/fonts/NotoSansKrFonts'
import { Typography } from 'src/components/common/Typography'
import { Divider, SmallDivider } from 'src/components/common/Divider'
import { Icon } from 'src/assets/svg/Icon'
import { useFormContext } from 'react-hook-form'
import { GiftSendFormItemsType } from 'src/types/react-hook-form'
import GiftSendInfo from 'src/pages/GiftSendPage/_components/GiftSendInfo'
import GiftSendMsgCard from 'src/pages/GiftSendPage/_components/GiftSendMsgCard'
import { GiftPurchaseProps } from 'src/pages/GiftSendPage/GiftPurchasePage/index'
import { paymentRadioButtonItemsType } from 'src/pages/CouponPurchasePage'

const GiftPurchaseView = (props: GiftPurchaseProps) => {
  const {
    isSubmiting,
    radioButtonItems,
    handlePaymentCallSubmit,
    handleServiceTermsModal,
    handleSetPaymentMethod,
    activePaymentMethod,
    couponDetailData,
  } = props
  const { formState } = useFormContext<GiftSendFormItemsType>()
  const { isValid } = formState

  const generalItems = radioButtonItems?.filter((item) => item.group === 'general') ?? []
  const easyItems = radioButtonItems?.filter((item) => item.group === 'easy') ?? []
  const easyCols = easyItems.length <= 2 ? 2 : 3

  return (
    <S.GiftPurchase.Container $option="flex_column">
      {/*받는 사람 정보*/}
      <GiftSendInfo {...props} />
      <Divider />
      {/*메시지 카드*/}
      <GiftSendMsgCard {...props} />
      <Divider />
      {/*결제수단*/}
      <S.GiftPurchase.Bottom.Container>
        <S.GiftPurchase.PaymentMethod.Container $option="flex_column" $row_gap="14px">
          <Typography $fontStyle={Noto_body1_m16}>결제수단</Typography>
          <S.GiftPurchase.PaymentMethod.Form>
            
            <S.GiftPurchase.PaymentMethod.Section $option="flex_column" $row_gap="10px">
              <Typography $fontStyle={Noto_body1_m16} $color="var(--black-50)">
                간편결제
              </Typography>
              <S.GiftPurchase.PaymentMethod.EasyGrid $cols={easyCols}>
                {easyItems.map(({ img, group: _group, ...rest }: paymentRadioButtonItemsType) => {
                  const isActive = activePaymentMethod === rest.id
                  return (
                    <S.GiftPurchase.PaymentMethod.FormItems key={rest.id} $active={isActive}>
                      <S.GiftPurchase.PaymentMethod.Radio
                        {...rest}
                        checked={isActive}
                        onChange={handleSetPaymentMethod}
                      />
                      <S.GiftPurchase.PaymentMethod.Label htmlFor={rest.id}>
                        {Boolean(img.src) ? (
                          <S.GiftPurchase.PaymentMethod.Image {...img} />
                        ) : (
                          <Typography $fontStyle={Noto_body1_r16}>{img.alt}</Typography>
                        )}
                      </S.GiftPurchase.PaymentMethod.Label>
                    </S.GiftPurchase.PaymentMethod.FormItems>
                  )
                })}
              </S.GiftPurchase.PaymentMethod.EasyGrid>
            </S.GiftPurchase.PaymentMethod.Section>
            <S.GiftPurchase.PaymentMethod.Section $option="flex_column" $row_gap="10px">
              <Typography $fontStyle={Noto_body1_m16} $color="var(--black-50)">
                일반결제
              </Typography>
              <S.GiftPurchase.PaymentMethod.GeneralList>
                {generalItems.map(({ img, group: _group, ...rest }: paymentRadioButtonItemsType) => {
                  const isActive = activePaymentMethod === rest.id
                  return (
                    <S.GiftPurchase.PaymentMethod.GeneralItem key={rest.id}>
                      <S.GiftPurchase.PaymentMethod.GeneralLabel htmlFor={rest.id}>
                        <S.GiftPurchase.PaymentMethod.GeneralRadio
                          {...rest}
                          $isChecked={isActive}
                          checked={isActive}
                          onChange={handleSetPaymentMethod}
                        />
                        <Typography $fontStyle={Noto_body1_r16}>{img.alt}</Typography>
                      </S.GiftPurchase.PaymentMethod.GeneralLabel>
                    </S.GiftPurchase.PaymentMethod.GeneralItem>
                  )
                })}
              </S.GiftPurchase.PaymentMethod.GeneralList>
            </S.GiftPurchase.PaymentMethod.Section>

          </S.GiftPurchase.PaymentMethod.Form>
        </S.GiftPurchase.PaymentMethod.Container>
        {/*주의사항*/}
        <S.GiftPurchase.Noti.Container $option="flex_row" $column_gap="14px">
          <S.GiftPurchase.Noti.Icon>
            <Icon.RedNoti />
          </S.GiftPurchase.Noti.Icon>
          <Typography $fontStyle={Noto_body2_r14} $color="var(--black-70)">
            수신인을 잘못 지정하여 다른 사람이 사용한 경우 책임은 사용자에게 있으며, 환불되지
            않습니다.
          </Typography>
        </S.GiftPurchase.Noti.Container>
        {/*약관*/}
        <S.GiftPurchase.Terms.Container $option="flex_column" $row_gap="12px">
          <SmallDivider />
          <Container $option="flex_column" $row_gap="4px">
            <Container $option="flex_row" $column_gap="6px">
              <Typography $fontStyle={Noto_body2_b14} $color="var(--black-70)">
                구매 및 개인정보 수집 및 이용 동의
              </Typography>
              <S.GiftPurchase.Terms.DetailChips onClick={handleServiceTermsModal}>
                상세보기
              </S.GiftPurchase.Terms.DetailChips>
            </Container>
            <Typography $fontStyle={Noto_body2_r14} $color="var(--black-50)">
              주문 내용을 확인하였으며, 구매 및 개인정보 수집 및 이용에 동의합니다.
            </Typography>
          </Container>
        </S.GiftPurchase.Terms.Container>
      </S.GiftPurchase.Bottom.Container>
      <S.GiftPurchase.Fixed.Container $option="flex_row">
        <Button
          option={ButtonOption3('active')}
          onClickFn={handlePaymentCallSubmit}
          disabled={isSubmiting || !couponDetailData?.SalePrice || !isValid}
        >
          선물 구매하기
        </Button>
      </S.GiftPurchase.Fixed.Container>
    </S.GiftPurchase.Container>
  )
}
export default GiftPurchaseView

const S = {
  GiftPurchase: {
    Container: styled(Container)``,
    Bottom: {
      Container: styled(Container)`
        padding: 40px 20px 80px;
      `,
    },
    Noti: {
      Container: styled(Container)`
        display: grid;
        grid-template-columns: 30px 1fr;
        align-items: center;
        margin: 20px 0 30px;
        padding: 16px;
        border-radius: 12px;
        background-color: var(--red-5);
      `,
      Icon: styled(Container)`
        display: flex;
        justify-content: center;
        align-items: center;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        background-color: var(--red-20);
      `,
    },
    Terms: {
      Container: styled(Container)<{ type?: 'terms' }>`
        background-color: var(--white);
      `,
      DetailChips: styled.section`
        display: flex;
        border-radius: 30px;
        border: 1px solid var(--black-20);
        background: var(--white);
        ${Noto_body3_m12};
        color: var(--black-50);
        width: fit-content;
        cursor: pointer;
        align-items: center;
        padding: 1px 6px;
      `,
    },
    PaymentMethod: {
      Container: styled(Container)`
        background-color: var(--white);
      `,
      Form: styled.form`
        display: flex;
        flex-direction: column;
        width: 100%;
        gap: 30px;
      `,
      Section: styled(Container)``,
      GeneralList: styled.div`
        display: flex;
        flex-direction: column;
        gap: 14px;
      `,
      GeneralItem: styled.div``,
      GeneralLabel: styled.label`
        display: flex;
        align-items: center;
        gap: 8px;
        cursor: pointer;
      `,
      GeneralRadio: styled.input.attrs({ type: 'radio', name: 'pay_method' })<{
        $isChecked: boolean
      }>`
        -webkit-appearance: none;
        appearance: none;
        position: relative;
        flex-shrink: 0;
        width: 22px;
        height: 22px;
        border-radius: 50%; 
        border:1px solid var(--black-20);
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        &::after {
          display: ${({ $isChecked }) => ($isChecked ? 'block' : 'none')};
          content: '';
          position: relative;
          width: 10px;
          height: 10px;
          border-radius: 50%;
          background-color: var(--brand-50);
        }
      `,
      EasyGrid: styled.div<{ $cols?: number }>`
        display: grid;
        width: 100%;
        grid-template-columns: repeat(${({ $cols = 3 }) => $cols}, 1fr);
        gap: 6px;
      `,
      FormItems: styled.section<{ $active: boolean }>`
        border-radius: 12px;
        border: 1px solid var(--black-10);
        background: var(--white);

        ${(props) =>
          props.$active &&
          css`
            border: 1px solid var(--black-70);
            background: var(--black-4);
          `}
      `,
      Image: styled.img<{ size: string }>`
        display: flex;
        width: ${(props) => props.size};
        height: auto;
      `,
      Radio: styled.input.attrs({ type: 'radio' }).attrs({ name: 'pay_method' })`display: none;`,
      Label: styled.label`
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 48px;
        padding: 12px 16px;
      `,
    },
    Fixed: {
      Container: styled(Container)`
        ${layoutMaxSize};
        position: fixed;
        left: 50%;
        bottom: 0;
        padding: 10px;
        border-top: 1px solid var(--black-4);
        background-color: var(--white);
        transform: translate(-50%, 0%);
        z-index: ${ZIndex.BottomFixedContents};
      `,
    },
  },
}
